import { createI18nextInstance, useI18nextTranslation } from "@sg-protect/federation-runtime/i18n";
import type { I18nextKey, I18nextTFunction } from "@sg-protect/federation-runtime";
import type { ModuleRegisterFunction } from "@sg-protect/shell";
import { en } from "./en.ts";

declare module "@sg-protect/federation-runtime" {
    interface I18nextResources {
        reviews: typeof en;
    }
}

const reviewsI18next = createI18nextInstance("reviews", en, {
    fr: async () => (await import("./fr.ts")).fr,
    de: async () => (await import("./de.ts")).de,
    es: async () => (await import("./es.ts")).es,
    nl: async () => (await import("./nl.ts")).nl
});

export const registerReviewsI18next: ModuleRegisterFunction = runtime => {
    reviewsI18next.register(runtime);
};

export type ReviewsTFunction = I18nextTFunction<"reviews">;

export type ReviewsTranslationKey = I18nextKey<"reviews">;

export function useReviewsTranslation() {
    return useI18nextTranslation("reviews", reviewsI18next.instance);
}
